export const Materials = {
  IRON: {
    name: "Iron",
    fixedMods: { damage: 1.0, attackSpeed: 1.1 },
  },
  STEEL: {
    name: "Steel",
    fixedMods: { damage: 1.2 },
    mods: { armor: 5 },
  },
  SILVER: {
    name: "Silver",
    fixedMods: { damage: 1.0, attackSpeed: 1.6 },
  },
  GOLD: {
    name: "Gold",
    fixedMods: { damage: 1.5, attackSpeed: 0.9 },
    mods: { critChance: 20 },
  },
};
